<template>
	<div id="app">

        <div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">BetRadar NCAAF Scores</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label>Year</label>
							<select @change="selectYear" class="form-control">
								<option value="">-- Select --</option>
								<option value="2017">2013</option>
                                <option value="2017">2014</option>
                                <option value="2017">2015</option>
                                <option value="2017">2016</option>
                                <option value="2017">2017</option>
                                <option value="2018" selected>2018</option>
                                <option value="2019">2019</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Season</label>
							<select @change="selectSeason" class="form-control">
								<option value="">-- Select --</option>
                                <option value="REG" selected>REG - Regular season</option>
							</select>
						</div>
					</div>
                    <div class="col">
						<div class="form-group" v-if="schedule.weeks">
							<label>Games</label>
							<select @change="selectSportEvent" class="form-control">
								<option value="">-- Select --</option>
                                <template v-for="week in schedule.weeks">
                                    <option v-for="sport_event in week.games" :value="sport_event.id">
                                        {{ sport_event.scheduled }} - {{ sport_event.status }} - {{ getSportEventName(sport_event) }}
                                    </option>
                                </template>
							</select>
						</div>
					</div>
				</div>
				
				<div>
					<p>These are the BetRadar endpoints used to build this page.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Schedule</td>
							<td>
                                <a :href="getScheduleEndpoint(true)" target="_blank">{{ getScheduleEndpoint(true) }}</a>
                            </td>
						</tr>
						<tr v-if="getPlayByPlayEndpoint()">
                            <td>Play by Play</td>
							<td>
                                <a :href="getPlayByPlayEndpoint(true)" target="_blank">{{ getPlayByPlayEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getGameBoxscoreEndpoint()">
                            <td>Game Boxscore</td>
							<td>
                                <a :href="getGameBoxscoreEndpoint(true)" target="_blank">{{ getGameBoxscoreEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getGameDepthChartEndpoint()">
                            <td>Game Depth Chart</td>
							<td>
                                <a :href="getGameDepthChartEndpoint(true)" target="_blank">{{ getGameDepthChartEndpoint(true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getGameRosterEndpoint()">
                            <td>Game Roster</td>
							<td>
                                <a :href="getGameRosterEndpoint(true)" target="_blank">{{ getGameRosterEndpoint(true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getGamestatisticsEndpoint()">
                            <td>Game Statistics</td>
							<td>
                                <a :href="getGamestatisticsEndpoint(true)" target="_blank">{{ getGamestatisticsEndpoint(true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getGameSummaryEndpoint()">
                            <td>Game Summary</td>
							<td>
                                <a :href="getGameSummaryEndpoint(true)" target="_blank">{{ getGameSummaryEndpoint(true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getSeasonalStatisticsEndpoint(this.home)">
                            <td>Seasonal Statistics Home Team</td>
							<td>
                                <a :href="getSeasonalStatisticsEndpoint(this.home, true)" target="_blank">{{ getSeasonalStatisticsEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getSeasonalStatisticsEndpoint(this.away)">
                            <td>Seasonal Statistics Away Team</td>
							<td>
                                <a :href="getSeasonalStatisticsEndpoint(this.away, true)" target="_blank">{{ getSeasonalStatisticsEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getTeamRosterEndpoint(this.home)">
                            <td>Team Roster Home Team</td>
							<td>
                                <a :href="getTeamRosterEndpoint(this.home, true)" target="_blank">{{ getTeamRosterEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>

                        <tr v-if="getTeamRosterEndpoint(this.away)">
                            <td>Team Roster Away Team</td>
							<td>
                                <a :href="getTeamRosterEndpoint(this.away, true)" target="_blank">{{ getTeamRosterEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
					</table>
				</div>
				
			</div>
		</div>

        <div v-if="sportEventId">
            <div id="accordion">
                <div class="card">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game" aria-expanded="true" aria-controls="collapseOne">
							Game
							</button>
						</h5>
					</div>

					<div id="game" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th>week</th>
                                    <th>scheduled</th>
                                    <th>home</th>
                                    <th>away</th>
                                    <th>venue</th>
                                    <th>weather</th>
                                    <th>broadcast</th>
                                </tr>
                                <tr>
                                    <td>
                                        number: {{ week.number }}<br>
                                        id: {{ week.id }}
                                    </td>
                                    <td>
                                        {{ sport_event.scheduled }}<br>
                                        id: {{ sport_event.id }}<br>
                                        status: {{ sport_event.status }}
                                    </td>
                                    <td>
                                        {{ sport_event.home }}<br>
                                        home_rotation: {{ sport_event.home_rotation }}
                                    </td>
                                    <td>
                                        {{ sport_event.away }}<br>
                                        away_rotation: {{ sport_event.away_rotation }}
                                    </td>
                                    <td>
                                        name: {{ sport_event.venue.name }}<br>
                                        id: {{ sport_event.venue.id }}<br>
                                        address: {{ sport_event.venue.address }}<br>
                                        city: {{ sport_event.venue.city }}<br>
                                        state: {{ sport_event.venue.state }}<br>
                                        country: {{ sport_event.venue.country }}<br>
                                        zip: {{ sport_event.venue.zip }}<br>
                                        capacity: {{ sport_event.venue.capacity }}<br>
                                        surface: {{ sport_event.venue.surface }}<br>
                                        type: {{ sport_event.venue.type }}<br>
                                    </td>
                                    <td>
                                        condition: {{ sport_event.weather.condition }}<br>
                                        humidity: {{ sport_event.weather.humidity }}<br>
                                        temperature: {{ sport_event.weather.temperature }}<br>
                                        wind direction: {{ sport_event.weather.wind.direction }}<br>
                                        wind speed: {{ sport_event.weather.wind.speed }}<br>
                                    </td>
                                    <td>
                                        <div v-if="sport_event.broadcast">
                                            network: {{ sport_event.broadcast.network }}
                                        </div>
                                    </td>
                                </tr>
                            </table>

						</div>
					</div>
				</div>

                <div class="card" v-if="play_by_play != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#playbyplay" aria-expanded="true" aria-controls="collapseOne">
							Play by Play
							</button>
						</h5>
					</div>

					<div id="playbyplay" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th>completed</th>
                                    <th>home</th>
                                    <th>away</th>
                                </tr>
                                <tr>
                                    <td>{{ play_by_play.completed }}</td>
                                    <td>
                                        <div v-if="play_by_play.home_team">
                                            id: {{ play_by_play.home_team.id }}<br>
                                            market: {{ play_by_play.home_team.market }}<br>
                                            name: {{ play_by_play.home_team.name }}<br>
                                            points: {{ play_by_play.home_team.points }}<br>
                                            remaining_challenges: {{ play_by_play.home_team.remaining_challenges }}<br>
                                            remaining_timeouts: {{ play_by_play.home_team.remaining_timeouts }}<br>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="play_by_play.away_team">
                                            id: {{ play_by_play.away_team.id }}<br>
                                            market: {{ play_by_play.away_team.market }}<br>
                                            name: {{ play_by_play.away_team.name }}<br>
                                            points: {{ play_by_play.away_team.points }}<br>
                                            remaining_challenges: {{ play_by_play.away_team.remaining_challenges }}<br>
                                            remaining_timeouts: {{ play_by_play.away_team.remaining_timeouts }}<br>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div v-for="quarter in play_by_play.quarters">

                                <h3>Quarter - {{ quarter.number}}</h3>

                                <table class="table">
                                    <tr>
                                        <th>clock</th>
                                        <th></th>
                                    </tr>
                                    <tr v-for="pbp in quarter.pbp">
                                        <td>{{ pbp.clock }}</td>
                                        <td>
                                            id: {{ pbp.id }}<br>
                                            <span v-if="pbp.type"> type: {{ pbp.type }}<br></span>
                                            <span v-if="pbp.event_type"> event_type: {{ pbp.event_type }}<br></span>
                                            <span v-if="pbp.sequence"> sequence: {{ pbp.sequence }}<br></span>
                                            <span v-if="pbp.summary"> summary: {{ pbp.summary }}<br></span>
                                            <span v-if="pbp.updated"> updated: {{ pbp.updated }}<br></span>
                                            <div v-if="pbp.winner">
                                                <span v-if="pbp.winner.outcome"> winner outcome: {{ pbp.winner.outcome }}<br></span>
                                                <span v-if="pbp.winner.team"> winner team: {{ pbp.winner.team }}<br></span>
                                            </div>

                                            <table class="table" v-if="pbp.actions">
                                                <tr>
                                                    <th>clock</th>
                                                    <th>details</th>
                                                    <th>participants</th>
                                                </tr>
                                                <tr v-for="action in pbp.actions">
                                                    <td>{{ action.clock }}</td>
                                                    <td>
                                                        id: {{ action.id }}<br>
                                                        <span v-if="action.type"> type: {{ action.type }}<br></span>
                                                        <span v-if="action.details"> details: <a :href="'https://api.sportradar.us/ncaafb-rt1' + action.details + '?api_key=' + apiKey" target="_blank">{{ action.details }}</a><br></span>
                                                        <span v-if="action.down"> down: {{ action.down }}<br></span>
                                                        <span v-if="action.play_type"> play_type: {{ action.play_type }}<br></span>
                                                        <span v-if="action.sequence"> sequence: {{ action.sequence }}<br></span>
                                                        <span v-if="action.side"> side: {{ action.side }}<br></span>
                                                        <span v-if="action.summary"> summary: {{ action.summary }}<br></span>
                                                        <span v-if="action.updated"> updated: {{ action.updated }}<br></span>
                                                        <span v-if="action.yard_line"> yard_line: {{ action.yard_line }}<br></span>
                                                        <span v-if="action.yfd"> yfd: {{ action.yfd }}<br></span>
                                                    </td>
                                                    <td>
                                                        <div v-if="action.participants">
                                                            <div v-for="participant in action.participants" style="padding-bottom:10px;">
                                                                <b>{{ participant.name }}</b><br>
                                                                <span v-if="participant.id"> id: {{ participant.id }}<br></span>
                                                                <span v-if="participant.jersey"> jersey: {{ participant.jersey }}<br></span>
                                                                <span v-if="participant.position"> position: {{ participant.position }}<br></span>
                                                                <span v-if="participant.team"> team: {{ participant.team }}<br></span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="game_boxscore != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-boxscore" aria-expanded="true" aria-controls="collapseOne">
							Game Boxscore
							</button>
						</h5>
					</div>

					<div id="game-boxscore" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
							<table class="table">
                                <tr>
                                    <th></th>
                                    <th>home team scoring</th>
                                    <th>away team scoring</th>
                                </tr>
                                <tr>
                                    <td>
                                        completed: {{ game_boxscore.completed }}<br>
                                        clock: {{ game_boxscore.clock }}<br>
                                        quarter: {{ game_boxscore.quarter }}<br>
                                        status: {{ game_boxscore.status }}<br>
                                    </td>
                                    <td>
                                        
                                        <div v-if="game_boxscore.home_team">
                                            points: {{ game_boxscore.home_team.points }}<br>
                                            <div v-for="scoring in game_boxscore.home_team.scoring" style="border-top: 1px solid #ccc">
                                                scoring: {{ scoring.points }}<br>
                                                quarter: {{ scoring.quarter }}<br>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        
                                        <div v-if="game_boxscore.away_team">
                                            points: {{ game_boxscore.away_team.points }}<br>
                                            <div v-for="scoring in game_boxscore.away_team.scoring" style="border-top: 1px solid #ccc">
                                                scoring: {{ scoring.points }}<br>
                                                quarter: {{ scoring.quarter }}<br>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <h3>scoring_drives</h3>

                            <table class="table">
                                <tr>
                                    <th>clock</th>
                                    <th>quarter</th>
                                    <th>sequence</th>
                                    <th>team</th>
                                    <th>scores</th>
                                </tr>
                                <tr v-for="scoring_drive in game_boxscore.scoring_drives">
                                    <td>{{ scoring_drive.clock }}</td>
                                    <td>{{ scoring_drive.quarter }}</td>
                                    <td>{{ scoring_drive.sequence }}</td>
                                    <td>{{ scoring_drive.team }}</td>
                                    <td>
                                        <table class="table">
                                            <tr>
                                                <th>clock</th>
                                                <th>id</th>
                                                <th>points</th>
                                                <th>summary</th>
                                                <th>team</th>
                                                <th>type</th>
                                            </tr>
                                            <tr v-for="score in scoring_drive.scores">
                                                <td>{{ score.clock }}</td>
                                                <td>{{ score.id }}</td>
                                                <td>{{ score.points }}</td>
                                                <td>{{ score.summary }}</td>
                                                <td>{{ score.team }}</td>
                                                <td>{{ score.type }}</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
						</div>
					</div>
				</div>

                <div class="card" v-if="game_depth_chart != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-depth-chart" aria-expanded="true" aria-controls="collapseOne">
							Game Depth Chart
							</button>
						</h5>
					</div>

					<div id="game-depth-chart" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <NFLDepthChart
                                :depth_chart="game_depth_chart.home_team"
                                team_role="home_team"
                            ></NFLDepthChart>

                            <NFLDepthChart
                                :depth_chart="game_depth_chart.away_team"
                                team_role="away_team"
                            ></NFLDepthChart>

						</div>
					</div>
				</div>

                <div class="card" v-if="game_roster != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-roster" aria-expanded="true" aria-controls="collapseOne">
							Game Roster
							</button>
						</h5>
					</div>

					<div id="game-roster" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <div v-if="game_roster.home_team">

                                <NFLRoster
                                    :roster="game_roster.home_team"
                                    team_role="home_team"
                                ></NFLRoster>

                            </div>

                            <div v-if="game_roster.away_team">
                                <NFLRoster
                                    :roster="game_roster.away_team"
                                    team_role="away_team"
                                ></NFLRoster>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="game_statistics != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-statistics" aria-expanded="true" aria-controls="collapseOne">
							Game Statistics
							</button>
						</h5>
					</div>

					<div id="game-statistics" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-if="game_statistics.home_team">
                                <NFLGameStatistics
                                    :statistics="game_statistics.home_team.statistics"
                                    :statistics_types="statistics_types"
                                ></NFLGameStatistics>
                            </div>
                            

                            <h3>away_team</h3>

                            <div v-if="game_statistics.away_team">
                                <NFLGameStatistics
                                    :statistics="game_statistics.away_team.statistics"
                                    :statistics_types="statistics_types"
                                ></NFLGameStatistics>
                            </div>
                            

						</div>
					</div>
				</div>

                <div class="card" v-if="game_summary != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game-summary" aria-expanded="true" aria-controls="collapseOne">
							Game Summary
							</button>
						</h5>
					</div>

					<div id="game-summary" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-for="(value, name) in game_summary.home_team">
                                <div v-if="typeof(value) == 'object'">
                                    
                                    {{ name }}: 
                                    <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                
                                        <div v-if="typeof(value_2) == 'object'">
                                    
                                            {{ name_2 }}: 
                                            <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                
                                                {{ name_3 }}: {{ value_3 }}
                                            
                                            </div>

                                        </div>
                                        <div v-else>
                                            {{ name_2 }}: {{ value_2 }}
                                        </div>
                                    
                                    </div>

                                </div>
                                <div v-else>
                                    {{ name }}: {{ value }}
                                </div>
                                
                            </div> 

                            <h3>away_team</h3>

                            <div v-for="(value, name) in game_summary.away_team">
                                <div v-if="typeof(value) == 'object'">
                                    
                                    {{ name }}: 
                                    <div v-for="(value_2, name_2) in value" style="padding-left:20px;">
                
                                        <div v-if="typeof(value_2) == 'object'">
                                    
                                            {{ name_2 }}: 
                                            <div v-for="(value_3, name_3) in value_2" style="padding-left:20px;">
                                                
                                                {{ name_3 }}: {{ value_3 }}
                                            
                                            </div>

                                        </div>
                                        <div v-else>
                                            {{ name_2 }}: {{ value_2 }}
                                        </div>
                                    
                                    </div>

                                </div>
                                <div v-else>
                                    {{ name }}: {{ value }}
                                </div>
                                
                            </div>                            

						</div>
					</div>
				</div>

                <div class="card" v-if="seasonal_statistics_home != [] && seasonal_statistics_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#seasonal-statistics" aria-expanded="true" aria-controls="collapseOne">
							Seasonal Statistics
							</button>
						</h5>
					</div>

					<div id="seasonal-statistics" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-if="seasonal_statistics_home.statistics">
                                <NFLSeasonalStatistics
                                    :statistics="seasonal_statistics_home"
                                    :statistics_types="statistics_types"
                                ></NFLSeasonalStatistics>
                            </div>
                            

                            <h3>away_team</h3>

                            <div v-if="seasonal_statistics_away.statistics">
                                <NFLSeasonalStatistics
                                    :statistics="seasonal_statistics_away"
                                    :statistics_types="statistics_types"
                                ></NFLSeasonalStatistics>
                            </div>
                                            
						</div>
					</div>
				</div>

                <div class="card" v-if="team_roster_home != [] && team_roster_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#team-roster" aria-expanded="true" aria-controls="collapseOne">
							Team Roster
							</button>
						</h5>
					</div>

					<div id="team-roster" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <NFLRoster
                                :roster="team_roster_home"
                                team_role="home_team"
                            ></NFLRoster>

                            <NFLRoster
                                :roster="team_roster_away"
                                team_role="away_team"
                            ></NFLRoster>
                                            
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'
import NFLGameStatistics from './components/NFLGameStatistics.vue'
import NFLSeasonalStatistics from './components/NFLSeasonalStatistics.vue'
import NFLDepthChart from './components/NFLDepthChart.vue'
import NFLRoster from './components/NFLRoster.vue'

export default {
    name: 'app',
    components: {
        NFLGameStatistics,
        NFLSeasonalStatistics,
        NFLDepthChart,
        NFLRoster,
	},
    created: function() {

        this.loadSchedule();
    
    },
    data: function() {
        return {            
            apiKey: '2tv38rmhyyegeq5dhqvz8a3d',
            year: 2018,
            season: "REG",
            schedule: [],
            play_by_play: [],
            sportEventId: '',
            sport_event: '',
            week: '',
            home: '',
            away: '',
            game_boxscore: [],
            game_depth_chart: [],
            game_roster: [],
            game_statistics: [],
            game_summary: [],
            seasonal_statistics_home: [],
            seasonal_statistics_away: [],
            team_roster_home: [],
            team_roster_away: [],
            statistics_types: [
                {
                    name: "two_point_conversion",
                    fields: [
                        "att",
                        "pass",
                        "rush",
                        "rec",
                        "failed",
                    ]
                },
                {
                    name: "touchdowns",
                    fields: [
                        "pass",
                        "rush",
                        "int",
                        "fum_ret",
                        "punt_ret",
                        "kick_ret",
                        "fg_ret",
                        "other",
                    ]
                },
                {
                    name: "third_down_efficiency",
                    fields: [
                        "att",
                        "conv",
                        "pct",
                        "pass",
                        "rush",
                        "pen",
                    ]
                },
                {
                    name: "rushing",
                    fields: [
                        "att",
                        "yds",
                        "avg",
                        "lg",
                        "td",
                        "fd",
                        "fd_pct",
                        "sfty",
                        "rz_att",
                        "fum",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "redzone_efficiency",
                    fields: [
                        "att",
                        "td",
                        "pct",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                    ]
                },
                {
                    name: "receiving",
                    fields: [
                        "tar",
                        "rec",
                        "yds",
                        "yac",
                        "fd",
                        "avg",
                        "td",
                        "lg",
                        "rz_tar",
                        "fum",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "punting",
                    fields: [
                        "punts",
                        "yds",
                        "net_yds",
                        "lg",
                        "blk",
                        "in20",
                        "tb",
                        "ret",
                        "sfty",
                        "avg",
                        "net_avg",
                        "ret_yds",
                        "avg_ret",
                        "in20_pct",
                        "tb_pct",
                    ]
                },
                {
                    name: "punt_return",
                    fields: [
                        "returns",
                        "yds",
                        "fc",
                        "lg",
                        "td",
                        "avg",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "penalty",
                    fields: [
                        "num",
                        "yds",
                        "fd",
                    ]
                },
                {
                    name: "passing",
                    fields: [
                        "att",
                        "cmp",
                        "yds",
                        "lg",
                        "sk",
                        "sk_yds",
                        "td",
                        "int",
                        "int_td",
                        "fd",
                        "sfty",
                        "rz_att",
                        "rating",
                        "avg",
                        "cmp_pct",
                        "cmp_avg",
                        "td_pct",
                        "int_pct",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "kickoffs",
                    fields: [
                        "kicks",
                        "yds",
                        "net_yds",
                        "lg",
                        "endzone",
                        "in20",
                        "tb",
                        "ret",
                        "avg",
                        "net_avg",
                        "ret_yds",
                        "avg_ret",
                        "in20_pct",
                        "tb_pct",
                    ]
                },
                {
                    name: "kick_return",
                    fields: [
                        "returns",
                        "yds",
                        "fc",
                        "lg",
                        "td",
                        "avg",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "goal_efficiency",
                    fields: [
                        "att",
                        "td",
                        "pct",
                    ]
                },
                {
                    name: "fumbles",
                    fields: [
                        "fum",
                        "lost",
                        "oob",
                        "own_rec",
                        "own_rec_yds",
                        "own_rec_td",
                        "force_fum",
                        "opp_rec",
                        "opp_rec_yds",
                        "opp_rec_td",
                    ]
                },
                {
                    name: "fourth_down_efficiency",
                    fields: [
                        "att",
                        "conv",
                        "pct",
                        "pass",
                        "rush",
                        "pen",
                    ]
                },
                {
                    name: "first_downs",
                    fields: [
                        "num",
                        "pass",
                        "rush",
                        "pen",
                    ]
                },
                {
                    name: "first_downs",
                    fields: [
                        "num",
                        "pass",
                        "rush",
                        "pen",
                    ]
                },
                {
                    name: "field_goal",
                    fields: [
                        "att",
                        "made",
                        "pct",
                        "lg",
                        "att_19",
                        "made_19",
                        "att_29",
                        "made_29",
                        "att_39",
                        "made_39",
                        "att_49",
                        "made_49",
                        "att_50",
                        "made_50",
                    ]
                },
                {
                    name: "extra_point",
                    fields: [
                        "att",
                        "made",
                        "pct",
                        "blk",
                    ]
                },
                {
                    name: "defensive_conversion",
                    fields: [
                        "att",
                        "cmp",
                        "failed",
                    ]
                },
                {
                    name: "defense",
                    fields: [
                        "tackle",
                        "ast",
                        "comb",
                        "tlost",
                        "sack",
                        "sack_yds",
                        "sfty",
                        "int",
                        "int_yds",
                        "int_lg",
                        "int_td",
                        "force_fum",
                        "fum_rec",
                        "fum_td",
                        "qh",
                        "pd",
                        "bk",
                        "sfty_1pt",
                        "sp_tackle",
                        "sp_ast",
                        "sp_comb",
                        "sp_force_fum",
                        "sp_fum_rec",
                        "misc_tackle",
                        "misc_ast",
                        "misc_comb",
                        "misc_force_fum",
                        "misc_fum_rec",
                    ]
                },
            ]
        }
    }, 
    methods: {
        getScheduleEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/${this.year}/${this.season}/schedule.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getPlayByPlayEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/${this.year}/${this.season}/${this.week.number}/${this.away}/${this.home}/pbp.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getPlayByPlayDetailsEndpoint: function(baseUrl, showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/${baseUrl}?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameBoxscoreEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/${this.year}/${this.season}/${this.week.number}/${this.away}/${this.home}/boxscore.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameDepthChartEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/${this.year}/${this.season}/${this.week.number}/${this.away}/${this.home}/depthchart.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameRosterEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/${this.year}/${this.season}/${this.week.number}/${this.away}/${this.home}/roster.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGamestatisticsEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/${this.year}/${this.season}/${this.week.number}/${this.away}/${this.home}/statistics.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getGameSummaryEndpoint: function(showBetradarUrl = false) {

            // no game selected
            if(this.home == ''
                || this.away == ''
                || this.week == ''
            ) {
                return '';
            }

            if(this.sport_event.status != 'inprogress'
                && this.sport_event.status != 'complete'
                && this.sport_event.status != 'closed'
            ) {
                return '';
            }

            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/${this.year}/${this.season}/${this.week.number}/${this.away}/${this.home}/summary.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSeasonalStatisticsEndpoint: function(team, showBetradarUrl = false) {
            
            if(team == '') return '';
            
            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/teams/${team}/${this.year}/${this.season}/statistics.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getTeamRosterEndpoint: function(team, showBetradarUrl = false) {

            if(team == '') return '';

            let url = `https://kaxmatrix.com/oddsapi/ncaafb-t1/teams/${team}/roster.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        loadSchedule: function() {

            // get full list of tournaments
            axios.get(this.getScheduleEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('schedule', response.data);

                this.schedule = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadPlayByPlay: function() {

            if(this.getPlayByPlayEndpoint() == '') return;

            axios.get(this.getPlayByPlayEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('play-by-play', response.data);

                this.play_by_play = response.data;
                
                this.loadPlayByPlayDetails();
            
            }, (error) => {
                console.log(error)
            });
        },

        loadPlayByPlayDetails: function() {
            return;

            let requestsCounter = 0;

            for(let quartersCount = 0; quartersCount < this.play_by_play.quarters.length; quartersCount++) {

                let currentQuarter = this.play_by_play.quarters[quartersCount];

                for(let pbpCount = 0; pbpCount < currentQuarter.pbp.length; pbpCount++) {
                    
                    let currentPbp = currentQuarter.pbp[pbpCount];

                    if(currentPbp.actions) {
                        for(let actionsCount = 0; actionsCount < currentPbp.actions.length; actionsCount++) {
                        
                            let currentAction = currentPbp.actions[actionsCount];
                            let requestUrl = this.getPlayByPlayDetailsEndpoint(currentAction.details);
                            requestsCounter++;

                            setTimeout(function() {

                                
                                console.log(new Date(), 'requestsCounter', requestsCounter);

                                axios.get(requestUrl, 
                                    { crossdomain: true })
                                .then((response) => {
                                    
                                    console.log('play-by-play detail', response.data);

                                    //this.play_by_play = response.data;
                                    
                                    //this.loadPlayByPlayDetails();
                                
                                }, (error) => {
                                    console.log(error)
                                });
                            }, requestsCounter * 500);
                            
                        }
                    }
                    
                }
            }
        },

        loadGameBoxscore: function() {

            if(this.getGameBoxscoreEndpoint() == '') return;

            axios.get(this.getGameBoxscoreEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-boxscore', response.data);

                this.game_boxscore = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameDepthChart: function() {

            if(this.getGameDepthChartEndpoint() == '') return;

            axios.get(this.getGameDepthChartEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-depth-chart', response.data);

                this.game_depth_chart = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameRoster: function() {

            if(this.getGameRosterEndpoint() == '') return;

            axios.get(this.getGameRosterEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-roster', response.data);

                this.game_roster = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameStatistics: function() {

            if(this.getGamestatisticsEndpoint() == '') return;

            axios.get(this.getGamestatisticsEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-statistics', response.data);

                this.game_statistics = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadGameSummary: function() {

            if(this.getGameSummaryEndpoint() == '') return;

            axios.get(this.getGameSummaryEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('game-summary', response.data);

                this.game_summary = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadSeasonalStatistics: function() {

            if(this.getSeasonalStatisticsEndpoint(this.home) == ''
                || this.getSeasonalStatisticsEndpoint(this.away) == ''
            ) return;

            axios.get(this.getSeasonalStatisticsEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('seasonal_statistics_home', response.data);

                this.seasonal_statistics_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getSeasonalStatisticsEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('seasonal_statistics_away', response.data);

                this.seasonal_statistics_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        loadTeamRoster: function() {

            if(this.getTeamRosterEndpoint(this.home) == ''
                || this.getTeamRosterEndpoint(this.away) == ''
            ) return;

            axios.get(this.getTeamRosterEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_roster_home', response.data);

                this.team_roster_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getTeamRosterEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_roster_away', response.data);

                this.team_roster_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        getSportEventName: function(sport_event) {

            let name = sport_event.home + ' vs ' + sport_event.away;

            return name;
        },

        selectYear: function(event) {
			
			this.year = event.target.value;
			this.loadSchedule();
        },

        selectSeason: function(event) {
			
			this.season = event.target.value;
			this.loadSchedule();
        },

        selectSportEvent: function(event) {
			  
            let sportEventId = event.target.value;
            let sport_event = '';
            let week = '';

            this.schedule.weeks.forEach(current_week => {
                
                let temp_sport_event = current_week.games.find(function(game) {
                    return game.id == sportEventId;
                });

                if(temp_sport_event) {
                    sport_event = temp_sport_event;
                    week = current_week;
                }
            });

            this.sportEventId = event.target.value;
            this.sport_event = sport_event;
            this.week = week;
            this.home = sport_event.home;
            this.away = sport_event.away;
            
            this.loadPlayByPlay();	
            this.loadGameBoxscore();
            this.loadGameDepthChart();
            this.loadGameRoster();
            this.loadGameStatistics();
            this.loadGameSummary();
            this.loadSeasonalStatistics();
            this.loadTeamRoster();
        },
    },
}
</script>